import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from '@angular/material/snack-bar';
import { LocalizedDatePipe } from '@app/core/pipes';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { ChartTypeSelectorComponent } from './components/chart-type-selector/chart-type-selector.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { MultiselectWithSearchComponent } from './components/multiselect-with-search/multiselect-with-search.component';
import { SearchMultiselectComponent } from './components/search-multiselect/search-multiselect.component';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { TooltipModalComponent } from './components/tooltip-modal/tooltip-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    TranslocoModule,
    MatIcon,
    MatSnackBarActions,
    MatSnackBarAction,
    MatSnackBarLabel,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatButtonToggle,
    MatButtonToggleGroup,
    MatCheckbox,
    MatInput,
    ConfirmationModalComponent,
    TooltipModalComponent,
    SnackBarComponent,
    LocalizedDatePipe,
    MultiselectWithSearchComponent,
    SearchMultiselectComponent,
    ChartTypeSelectorComponent,
    FileInputComponent,
  ],
  exports: [
    ConfirmationModalComponent,
    TooltipModalComponent,
    SnackBarComponent,
    LocalizedDatePipe,
    MultiselectWithSearchComponent,
    SearchMultiselectComponent,
    ChartTypeSelectorComponent,
    FileInputComponent,
  ],
  providers: [LocalizedDatePipe, { provide: TRANSLOCO_SCOPE, useValue: 'shared' }],
})
export class SharedModule {}
